import { SaveOutlined } from "@ant-design/icons";
import { Button, message, Tooltip } from "antd";
import { SaveReportModal } from "./save-report-modal";
import { useState } from "react";
import { TApiSavedReport, TApiSavedReportFormObject, TApiSavedReportKind } from "@timenotes/shared/src/services/saved-reports/saved-reports-types";
import { isEqual } from "lodash";
import { useUpdateSavedReportMutation } from "@timenotes/shared/src/services/saved-reports/queries/use-update-saved-report-mutation";

interface Props {
  savedReport?: TApiSavedReport // existing saved report button
  kind: TApiSavedReportKind
  data: TApiSavedReport['data']
}

export function SaveReportButton(props: Props) {
  const {
    savedReport,
    kind,
    data,
  } = props

  const [visible, setVisible] = useState(false)
  const didDataChange = !isEqual(savedReport?.data, data)

  const updateSavedReportMutation = useUpdateSavedReportMutation()

  const handleSave = () => {
    if (savedReport?.id) {
      updateSavedReportMutation.mutate({
        id: savedReport.id,
        data: data,
      }, {
        onSuccess: () => {
          message.success('Report filters saved.')
        },
        onError: () => {
          message.error('Something went wrong!')
        }
      })
    } else {
      setVisible(true) 
    }
  }

  return (
    <>
      <Tooltip title={savedReport?.id && !didDataChange ? 'Saved report cannot be updated as no filters have changed.' : undefined}>
        <Button
          disabled={savedReport?.id && !didDataChange}
          icon={<SaveOutlined />}
          onClick={handleSave}
        >
          Save
        </Button>
      </Tooltip>

      <SaveReportModal
        savedReport={{
          kind: kind,
          data: data,
        }}

        visible={visible}
        onCancel={() => setVisible(false)}
      />
    </>
  )
}